# GraphQL mutation to create a email automation

mutation CreateEmailAutomation($emailAutomation: CreateEmailAutomationInputFieldInput!) {
    createEmailAutomation(input: {emailAutomation: $emailAutomation}) {
        emailAutomation {
            id
            emailList {
                id
            }
            entersStage {
                id
            }
            exitsStage {
                id
            }
            sendFromUser {
                id
            }
            delay {
                unit
                timespan
            }
        }
    }
}
